<section class="dash-page">

  <!-- Hidden job-card whose `candidateSupplyTemplate` + `apply()` back the
       Top Job Spotlight "Apply" button. The unknown `viewSize` keeps every
       visual `*ngIf` branch false, so only the top-level `<ng-template>`
       refs register via ViewChild. `JobData = {}` stays truthy so the job-card's
       `ngOnInit` (line 275: `this.JobData.showAllSkills = false`) doesn't NPE. -->
  <app-job-card #spotlightJobCardRef
                [viewSize]="'__spotlight_apply_only__'"
                [JobData]="{}"
                style="display:none"></app-job-card>

  <!-- Welcome -->
  <div class="welcome">
    <div class="welcome-left">
      <h1>{{greeting}}{{ userFirstName ? ', ' + userFirstName : '' }} 👋  </h1>
      <!-- Static counts for now; wire to backend (follow-ups / interviews today) later. -->
      <p>{{ todayFormatted }}<span class="welcome-sep">·</span>3 follow-ups due<span class="welcome-sep">·</span>2 interviews today</p>
    </div>
    <div class="welcome-right">
      <button class="btn btn-outline" type="button" disabled><ng-icon name="tablerUsers" class="gs-ico"></ng-icon> My Bench</button>
      <button class="btn btn-primary" type="button" (click)="onAddNewCandidate()"><ng-icon name="tablerPlus" class="gs-ico"></ng-icon> Add New Candidate</button>
    </div>
  </div>

  <!-- Quick actions -->
  <div class="quick-bar">
    <span class="quick-bar-label">Quick Actions</span>
    <button class="qb-btn qb-primary" type="button" (click)="onAddNewCandidate()"><ng-icon name="tablerUserPlus" class="gs-ico"></ng-icon> Add New Candidate</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerUser" class="gs-ico"></ng-icon> Add to Bench</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerCalendar" class="gs-ico"></ng-icon> Log Interview</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerPhone" class="gs-ico"></ng-icon> Follow Up Call</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerMessage" class="gs-ico"></ng-icon> Message Client</button>
    <span class="quick-bar-divider"></span>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerSearch" class="gs-ico"></ng-icon> Find Jobs for Bench</button>
    <span class="qb-search is-disabled" aria-disabled="true">
      <ng-icon name="tablerSearch" class="gs-ico"></ng-icon>
      <span>Search candidates, jobs…</span>
      <span class="qb-shortcut">⌘K</span>
    </span>
  </div>

  <!-- AI Insights -->
  <div class="insights-strip">
    <div class="insight-card" [ngClass]="'insight-' + item.tone" *ngFor="let item of data.insights">
      <div class="insight-hdr">
        <span class="insight-icon" [ngClass]="'insight-icon-' + item.tone">
          <ng-icon *ngIf="item.tone==='amber'"  name="tablerClock"         class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='green'"  name="tablerActivity"      class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='blue'"   name="tablerSearch"        class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='red'"    name="tablerAlertCircle"   class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='purple'" name="tablerStar"          class="gs-ico gs-ico-xl"></ng-icon>
        </span>
        <span class="insight-tag" [ngClass]="'insight-tag-' + item.tone">{{ item.tag }}</span>
        <span class="insight-ai"><ng-icon name="tablerRobot" class="gs-ico"></ng-icon> Sumo AI</span>
      </div>
      <div class="insight-body" [innerHTML]="item.body"></div>
      <a class="insight-cta" href="javascript:void(0)">{{ item.cta }}</a>
    </div>
  </div>

  <!-- KPI cards -->
  <div class="stat-grid">
    <div class="stat-card" [ngClass]="'acc-' + kpi.accent" *ngFor="let kpi of data.kpis">
      <div class="s-icon" [ngClass]="'s-icon-' + kpi.accent">
        <gs-dash-icon [name]="kpi.iconName" class="gs-ico gs-ico-lg"></gs-dash-icon>
      </div>
      <div class="s-label">{{ kpi.label }}</div>
      <div class="s-value">{{ kpiOverrides[kpi.label] !== undefined ? kpiOverrides[kpi.label] : kpi.value }}</div>
      <div class="s-sub">{{ kpi.sub }}</div>
      <!-- Live trend pill when This Week Summary v1.0.252 fields
           `activeCandidatesStats` / `submissionsStats` are present;
           otherwise falls back to the mock `kpi.trend`. -->
      <div class="s-trend" [ngClass]="'trend-' + (kpiTrendOverrides[kpi.label]?.dir || kpi.trend.dir)">
        <gs-dash-icon [name]="(kpiTrendOverrides[kpi.label]?.dir || kpi.trend.dir)==='up' ? 'tablerArrowUp' : (kpiTrendOverrides[kpi.label]?.dir || kpi.trend.dir)==='down' ? 'tablerArrowDown' : 'tablerArrowRight'"
                      class="gs-ico gs-ico-sm"></gs-dash-icon>
        {{ kpiTrendOverrides[kpi.label]?.text || kpi.trend.text }}
      </div>
    </div>
  </div>

  <!-- Row 1: Active Candidates · Top Job Spotlight — awaiting backend APIs (cards render empty) -->
  <div class="section-row" style="grid-template-columns: 1fr 1.4fr;">
    <div class="card active-candidates-card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerUsers" class="gs-ico gs-ico-md"></ng-icon> Active Candidates</div>
        <button class="card-action" type="button" (click)="goToActiveCandidatesList()">My bench →</button>
      </div>
      <div class="list-scroll">
        <gs-skeleton-list *ngIf="loadingActiveCandidates && !activeCandidates.length" [rows]="5" variant="row"></gs-skeleton-list>
        <div class="cand-row"
             *ngFor="let c of activeCandidates"
             [class.selected]="c.id === selectedCandidateId"
             (click)="selectActiveCandidate(c)"
             role="button"
             tabindex="0"
             (keydown.enter)="selectActiveCandidate(c)">
          <div class="cand-av" [style.background]="c.gradient" [style.color]="c.color">{{ c.initials }}</div>
          <div class="cand-info">
            <div class="cand-name" [title]="c.name">{{ c.name }}</div>
            <div class="cand-meta" [title]="c.meta">{{ c.meta }}</div>
          </div>
          <span class="pill" [ngClass]="'pill-' + c.status.tone">{{ c.status.label }}</span>
        </div>
        <div class="dash-empty" *ngIf="!loadingActiveCandidates && !activeCandidates.length">No active candidates found</div>
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <!-- `card-title-text` / `spotlight-card-title` keep this header on one
             line: the static label never wraps and the live candidate-name
             suffix truncates instead, so the card's divider stays level with
             the Active Candidates card beside it. -->
        <div class="card-title spotlight-card-title">
          <ng-icon name="tablerStar" class="gs-ico gs-ico-md"></ng-icon>
          <span class="card-title-text">Top Job Spotlight</span>
          <span class="spotlight-job-ctx" *ngIf="selectedCandidateName" [title]="selectedCandidateName"> · {{ selectedCandidateName }}</span>
        </div>
        <a class="card-action" href="javascript:void(0)"
           [class.disabled]="!selectedCandidateId"
           (click)="goToJobSpotlightTab()">View all →</a>
      </div>

      <div class="spotlight-tabs">
        <button class="sp-tab"
                type="button"
                [class.active]="activeJobSpotlightTab === 'applied'"
                (click)="selectJobSpotlight('applied')">
          Applied
          <span class="sp-tab-count" [title]="jobSpotlightTabCount('applied')">{{ jobSpotlightTabCount('applied') | compactCount }}</span>
        </button>
        <button class="sp-tab"
                type="button"
                [class.active]="activeJobSpotlightTab === 'market'"
                (click)="selectJobSpotlight('market')">
          Marketplace
          <span class="sp-tab-count" [title]="jobSpotlightTabCount('market')">{{ jobSpotlightTabCount('market') | compactCount }}</span>
        </button>
      </div>

      <div class="list-scroll">
        <gs-skeleton-list *ngIf="jobSpotlightLoading && !jobSpotlightRows.length" [rows]="4" variant="row"></gs-skeleton-list>

        <div class="spotlight-row" *ngFor="let j of jobSpotlightRows">
          <span class="spotlight-rank">{{ j.rank }}</span>
          <div class="job-av" [style.background]="j.gradient" [style.color]="j.color">{{ j.initials }}</div>
          <div class="spotlight-info">
            <div class="spotlight-name" [title]="j.name">{{ j.name }}</div>
            <div class="spotlight-job" [title]="j.meta">{{ j.meta }}</div>
            <div class="spotlight-meta" [title]="j.sub">{{ j.sub }}</div>
          </div>
          <div class="match-badge" [ngClass]="'mb-' + j.matchTone"
               style="margin-right:8px;cursor:context-menu;"
               (click)="$event.stopPropagation()">
            <div class="match-pct">{{ j.match != null ? j.match + '%' : '-' }}</div>
            <div class="match-lbl">{{ j.match != null && j.match < 80 ? 'Fit' : 'Fit' }}</div>
          </div>
          <button class="btn" [ngClass]="j.actionPrimary ? 'btn-primary' : 'btn-outline'"
                  type="button"
                  style="padding:5px 10px;font-size:10px;"
                  (click)="openJobSpotlightAction(j, $event)">{{ j.action }}</button>
        </div>

        <div class="dash-empty" *ngIf="!selectedCandidateId && !jobSpotlightLoading">
          Select a candidate from the left to view matching jobs
        </div>
        <div class="dash-empty" *ngIf="selectedCandidateId && !jobSpotlightLoading && !jobSpotlightRows.length">
          No jobs found
        </div>
      </div>


      <div class="sumo-ai-block" *ngIf="data.sumoRec?.body">
        <div class="sumo-ai-hdr">
          <div class="sumo-ai-icon"><ng-icon name="tablerRobot" class="gs-ico gs-ico-md"></ng-icon></div>
          <div class="sumo-ai-title">Sumo AI Recommendation</div>
          <span class="sumo-ai-badge">AI</span>
        </div>
        <div class="sumo-ai-body" [innerHTML]="data.sumoRec.body"></div>
        <div class="sumo-ai-actions">
          <button class="btn btn-primary" type="button" disabled style="font-size:11px;padding:6px 12px;"><ng-icon name="tablerSend" class="gs-ico"></ng-icon> Submit Joe Smith</button>
          <button class="btn btn-outline" type="button" disabled style="font-size:11px;padding:6px 12px;">View Job</button>
          <button class="btn btn-outline" type="button" disabled style="font-size:11px;padding:6px 12px;margin-left:auto;">Dismiss</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Row 2: Interviews Today · Today's Activity · Weekly Metrics (Interviews Today awaits backend API) -->
  <div class="section-row" style="grid-template-columns: 1fr 1fr 0.8fr;">
    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerCalendar" class="gs-ico gs-ico-md"></ng-icon> Interviews Today</div>
        <span class="pill pill-gray">0 today</span>
      </div>
      <div class="interview-item" *ngFor="let iv of data.interviewsToday">
        <div class="iv-time-block">
          <div class="iv-time">{{ iv.time }}</div>
          <div class="iv-ampm">{{ iv.ampm }}</div>
        </div>
        <div class="iv-divider"></div>
        <div class="iv-info">
          <div class="iv-name" [title]="iv.name">{{ iv.name }}</div>
          <div class="iv-role" [title]="iv.role">{{ iv.role }}</div>
          <div class="iv-company" [title]="iv.company">{{ iv.company }}</div>
        </div>
        <div class="iv-status">
          <span class="pill" [ngClass]="'pill-' + iv.tone" style="font-size:9px;">{{ iv.status }}</span>
          <div class="iv-type">
            <gs-dash-icon
              [name]="iv.type === 'Phone' ? 'tablerPhone' : (iv.type === 'On-site' || iv.type === 'Onsite' || iv.type === 'In-person') ? 'tablerHome' : 'tablerVideo'"
              class="gs-ico gs-ico-sm"></gs-dash-icon>
            {{ iv.type }}
          </div>
        </div>
      </div>
      <div class="dash-empty" *ngIf="!data.interviewsToday?.length">No interviews today</div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerClock" class="gs-ico gs-ico-md"></ng-icon> Today's Activity</div>
        <span style="font-size:11px;color:var(--gs-gray-400);">
          {{ todayActivity.length ? (todayActivityTotalCount || todayActivity.length) : data.todayActivityCount }} events
        </span>
      </div>
      <gs-skeleton-list *ngIf="loadingTodayActivity && !todayActivity.length" [rows]="5" variant="activity"></gs-skeleton-list>
      <div class="activity-list list-scroll">
        <div class="activity-item" *ngFor="let a of (todayActivity.length ? todayActivity : data.todayActivity)">
          <span class="act-dot" [style.background]="
            a.tone==='green'  ? 'var(--gs-green)' :
            a.tone==='amber'  ? 'var(--gs-amber)' :
            a.tone==='red'    ? 'var(--gs-red)' :
            a.tone==='blue'   ? 'var(--gs-blue)' :
            a.tone==='gray'   ? 'var(--gs-gray-300)' : 'var(--gs-purple-light)'">
          </span>
          <div class="act-text" [innerHTML]="a.text"></div>
          <!-- View-summary rows carry a literal label (e.g. "Yesterday", timeIsLabel:true);
               event rows carry an epoch time that gets formatted. Piping the literal
               through timezoneDate would blank it out (unparseable), so branch. -->
              <span class="act-time">{{ a.timeIsLabel ? a.time : (a.time | timezoneDate:'h:mm a') }}</span>
        </div>
      </div>
      <div class="dash-empty" *ngIf="!loadingTodayActivity && !todayActivity.length && !data.todayActivity?.length">
        No activity today
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerActivity" class="gs-ico gs-ico-md"></ng-icon> Weekly Activity Metrics</div>
        <span style="font-size:11px;color:var(--gs-gray-400);">{{ weeklyMetrics?.range }}</span>
      </div>
      <div class="dash-loading" *ngIf="loadingWeekly && !weeklyMetrics">Loading…</div>
      <div class="goal-item" *ngFor="let g of weeklyMetrics?.goals">
        <div class="goal-hdr">
          <span class="goal-name">{{ g.name }}</span>
          <!-- Submissions is a cumulative counter (no goal target), so it
               shows a single count from the API's `total` field (mapped to
               `g.target`). Goal-based rows keep the
               `{current} / {target}` progress format. -->
          <span class="goal-nums" *ngIf="g.totalOnly"><strong>{{ g.target }}</strong></span>
          <span class="goal-nums" *ngIf="!g.totalOnly"><strong>{{ g.current }}</strong> / {{ g.target }}</span>
        </div>
        <div class="goal-track" *ngIf="!g.totalOnly">
          <div class="goal-fill"
               [style.width]="(g.target ? (g.current / g.target) * 100 : 0) + '%'"
               [style.background]="g.fill"></div>
        </div>
      </div>
      <div class="dash-empty" *ngIf="!loadingWeekly && (!weeklyMetrics || weeklyMetrics.goals.length === 0)">
        No metrics for this week.
      </div>
    </div>
  </div>

  <!-- Row 3: Recent Submissions · Needs Your Attention (right card awaits backend API) -->
  <div class="section-row" style="grid-template-columns: 1.2fr 1fr;">
    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerSend" class="gs-ico gs-ico-md"></ng-icon> Recent Submissions</div>
        <button class="card-action" type="button" (click)="goToMyBench()">View all →</button>
      </div>
      <div class="list-scroll">
        <gs-skeleton-list *ngIf="loadingSubmissions && !recentSubmissions.length" [rows]="5" variant="row"></gs-skeleton-list>
        <div class="sub-row" *ngFor="let s of recentSubmissions">
          <div class="cand-av" [style.background]="s.gradient" [style.color]="s.color">{{ s.initials }}</div>
          <div class="sub-info">
            <div class="sub-name" [title]="s.name">{{ s.name }}</div>
            <div class="sub-job" [title]="s.job">{{ s.job }}</div>
            <div class="sub-company" [title]="s.company">{{ s.company }}</div>
          </div>
          <div class="sub-right">
            <span class="stage" [ngStyle]="stageStyle(s.statusRaw)">{{ s.stage }}</span>
            <!-- <div class="sub-date">{{ s.date }}</div> -->
             <div class="sub-date">{{ s.date | timezoneDate:'MMMM dd, yyyy' }}</div>
          </div>
          <div class="match-badge" [ngClass]="'mb-' + s.matchTone"
               style="margin-left:8px;cursor:context-menu;">
            <div class="match-pct">{{ s.match != null ? s.match + '%' : '-' }}</div>
            <div class="match-lbl">{{ s.match != null && s.match < 80 ? 'Fit' : 'Fit' }}</div>
          </div>
        </div>
        <div class="dash-empty" *ngIf="!loadingSubmissions && recentSubmissions.length === 0">
          No recent submissions.
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerAlertCircle" class="gs-ico gs-ico-md"></ng-icon> Needs Your Attention</div>
        <span class="pill pill-gray">0 urgent</span>
      </div>
      <div class="attn-item" *ngFor="let n of data.needsAttention">
        <span class="act-dot" [style.background]="
          n.dotTone==='red'   ? 'var(--gs-red)' :
          n.dotTone==='amber' ? 'var(--gs-amber)' :
          n.dotTone==='blue'  ? 'var(--gs-blue)' :
          n.dotTone==='green' ? 'var(--gs-green)' : 'var(--gs-gray-300)'">
        </span>
        <div class="attn-body">
          <span [innerHTML]="n.body"></span>
          <div class="attn-pill-wrap">
            <span class="pill" [ngClass]="'pill-' + n.pill.tone" style="font-size:9px;">{{ n.pill.label }}</span>
          </div>
        </div>
        <div class="attn-actions">
          <button class="btn" [ngClass]="n.action.primary ? 'btn-primary' : 'btn-outline'" type="button">{{ n.action.label }}</button>
        </div>
      </div>
      <div class="dash-empty" *ngIf="!data.needsAttention?.length">Nothing needs your attention</div>
    </div>
  </div>

  <!-- Row 4: Submission Pipeline · Offer Pipeline Tracker -->
  <div class="section-row row-2">
    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerFilter" class="gs-ico gs-ico-md"></ng-icon> Submission Pipeline</div>
        <button class="card-action" type="button" (click)="goToMyBench()">View all →</button>
      </div>
      <div class="card-body">
        <div class="funnel">
          <div class="funnel-row" *ngFor="let s of (submissionFunnelRows || data.submissionFunnel)">
            <span class="funnel-lbl">{{ s.label }}</span>
            <div class="funnel-bar-wrap">
              <div class="funnel-bar"
                   [style.width]="s.pct + '%'"
                   [style.background]="s.bg"
                   [style.color]="s.color"
                   [style.borderLeft]="'3px solid ' + s.border">
                <span [title]="s.num">{{ s.num | compactCount }}</span>
              </div>
            </div>
            <span class="funnel-num" [title]="s.num">{{ s.num | compactCount }}</span>
          </div>
        </div>
        <div class="dash-empty" *ngIf="!(submissionFunnelRows || data.submissionFunnel)?.length">
          No submission data found
        </div>
        <div class="funnel-rates">
          <div class="funnel-rate" *ngFor="let r of (submissionFunnelRates || data.funnelRates)" [class.mid]="r.mid">
            <div class="funnel-rate-val" [ngClass]="r.tone">{{ r.val }}</div>
            <div class="funnel-rate-lbl">{{ r.lbl }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerFileText" class="gs-ico gs-ico-md"></ng-icon> Offer Pipeline Tracker</div>
        <div style="display:flex;align-items:center;gap:8px;">
          <span class="pill pill-amber" *ngIf="offerStages[1]?.val">{{ offerStages[1].val }} awaiting response</span>
          <button class="card-action" type="button" (click)="goToMyBench()">View all →</button>
        </div>
      </div>
      <div class="offer-track-grid" *ngIf="offerStages.length">
        <div class="offer-stage-cell" [ngClass]="s.cls" *ngFor="let s of offerStages">
          <div class="osc-label">{{ s.label }}</div>
          <div class="osc-value">{{ s.val }}</div>
          <div class="osc-sub">{{ s.sub }}</div>
        </div>
      </div>
      <div class="list-scroll">
        <gs-skeleton-list *ngIf="loadingOffers && !offers.length" [rows]="5" variant="row"></gs-skeleton-list>
        <div class="offer-row" *ngFor="let o of offers">
          <div class="offer-av" *ngIf="o.photoUrl">
            <img [src]="o.photoUrl" alt="avatar" (error)="$any($event.target).style.display='none'">
          </div>
          <div class="offer-av" *ngIf="!o.photoUrl"
            [style.background]="getAvatarColor(o.name)"
            [style.color]="getAvatarTextColor(o.name)">{{ o.initials }}</div>
          <div class="offer-info">
            <div class="offer-name" [title]="o.name">{{ o.name }}</div>
            <div class="offer-role" [title]="o.role">{{ o.role }}</div>
            <div class="offer-company" [title]="o.company">{{ o.company }}</div>
          </div>
          <div class="offer-right">
            <div class="offer-amount">{{ o.amount }}</div>
            <span class="pill" [ngClass]="'pill-' + o.tone" style="font-size:9px;">
              <gs-dash-icon [name]="o.statusIcon" class="gs-ico gs-ico-sm"></gs-dash-icon> {{ o.statusText }}
            </span>
            <span class="offer-deadline" *ngIf="o.deadline">{{ o.deadline }}</span>
          </div>
        </div>
        <div class="dash-empty" *ngIf="!loadingOffers && offers.length === 0">
          No offers yet.
        </div>
      </div>
    </div>
  </div>

  <!-- Slots + This Week -->
  <div class="section-row row-2">
    <div class="card">
      <div class="card-hdr">
        <!-- Eyebrow-style header per gigsumo_unified(48).html mock
             (line 1861): small uppercase gray label + plan pill, no
             inline icon. Matches recruiter dashboard. -->
        <div class="card-title slot-eyebrow">Job & Candidate Slots</div>
        <span class="pill pill-purple" *ngIf="slots.plan">{{ slots.plan }}</span>
      </div>
      <div class="donut-wrap">
        <!-- SVG ring donut with 2-line center label ("N/M" + "USED").
             Replaces the CSS conic-gradient pie so the widget reads as
             a donut rather than a filled wheel. Mirrors the recruiter
             dashboard implementation. -->
        <div class="donut-svg-wrap">
          <svg viewBox="0 0 64 64" class="donut-svg" aria-hidden="true">
            <circle class="donut-ring-bg" cx="32" cy="32" r="25"/>
            <circle class="donut-ring-used" cx="32" cy="32" r="25"
                    [attr.stroke-dashoffset]="donutDashoffset()"/>
          </svg>
          <div class="donut-center">
            <div class="donut-val">{{ slots.used }}/{{ slots.allocated }}</div>
            <div class="donut-sub">Used</div>
          </div>
        </div>
        <div class="donut-legend">
          <div class="dl-item">
            <span class="dl-dot" style="background:var(--gs-purple-light)"></span>
            Slots Used <span class="dl-val">{{ slots.used }}</span>
          </div>
          <div class="dl-item">
            <span class="dl-dot" style="background:#DDD6FE"></span>
            Slots Open <span class="dl-val open-val">{{ slots.open }}</span>
          </div>
          <div class="dl-item">
            <span class="dl-dot" style="background:var(--gs-gray-200)"></span>
            Allocated <span class="dl-val">{{ slots.allocated }}</span>
          </div>
        </div>
      </div>
      <div class="slots-grid">
        <div class="slots-cell">
          <div class="slots-val" style="color:var(--gs-purple-light);">{{ slots.allocated }}</div>
          <div class="slots-lbl">Allocated</div>
        </div>
        <div class="slots-cell">
          <div class="slots-val">{{ slots.used }}</div>
          <div class="slots-lbl">Used</div>
        </div>
        <div class="slots-cell">
          <div class="slots-val green">{{ slots.open }}</div>
          <div class="slots-lbl">Open</div>
        </div>
        <div class="slots-cell">
          <div class="slots-val blue">{{ slots.totalPosted }}</div>
          <div class="slots-lbl">Total Posted</div>
        </div>
      </div>
      <div class="slots-cta" role="button" tabindex="0"
           (click)="goToPlanQuota()"
           (keydown.enter)="goToPlanQuota()"
           (keydown.space)="goToPlanQuota()">
        <!-- Filled purple icon tile per mock (gigsumo_unified(48).html:
             871-872). Matches recruiter dashboard. -->
        <span class="slots-cta-icon">
          <ng-icon name="tablerTrendingUp" class="gs-ico"></ng-icon>
        </span>
        <div style="flex:1">
          <div><strong>Need more slots?</strong></div>
          <div style="font-size:11px;color:var(--gs-gray-500);">Upgrade to Pro — unlimited slots</div>
        </div>
        <ng-icon name="tablerArrowRight" class="gs-ico gs-ico-md"></ng-icon>
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title">This Week</div>
        <span class="card-action">{{ thisWeek.range }}</span>
      </div>
      <div class="tw-row" *ngFor="let r of thisWeek.rows">
        <span class="tw-label">
          <span class="tw-dot" [style.background]="r.color"></span>
          {{ r.label }}
        </span>
        <span>
          <span class="tw-val">{{ r.val }}</span>
          <span class="tw-delta" [ngClass]="r.delta.dir">
            <gs-dash-icon [name]="r.delta.dir==='up' ? 'tablerArrowUp' : r.delta.dir==='down' ? 'tablerArrowDown' : 'tablerArrowRight'"
                          class="gs-ico gs-ico-sm"></gs-dash-icon>
            {{ r.delta.text }}
          </span>
        </span>
      </div>
    </div>
  </div>

</section>
